import { useCallback } from 'react';

import { useOnWatchedTimeChanged } from '../../feature-player/hooks/tracker/use-on-watched-time-changed';
import { clearAutopskipTimer } from '../../feature-player/ui/skin/next-episode-skip-button-group/hooks/use-is-auto-skip-enabled';
import { cleanPlayingParams } from '../../feature-player/utils/clean-playing-params';
import { useStopPlayingContent } from '../../player-manager/helpers/stop-playing-content';

interface Props {
    onClose?: () => void;
}

export const useFilmHandlers = ({ onClose }: Props) => {
    const handleWatchedTimeChange = useOnWatchedTimeChanged();

    const stopPlayingContent = useStopPlayingContent();

    const handleClose = useCallback(() => {
        clearAutopskipTimer();
        onClose?.();
        cleanPlayingParams();
        stopPlayingContent();
    }, [onClose, stopPlayingContent]);

    return { handleWatchedTimeChange, handleClose };
};
